import { Row, Col, InfoCard, Card, InfoIcon } from 'components/ui/';
import { useTranslation } from 'next-i18next';
import i18n from '../../../../i18n'; // eslint-disable-line

const Step01 = () => {
	const [t] = useTranslation(['translation']);

	return (
		<>
			<Card.Title>{t('impfschaeden.erfassen.danke_zeit')}</Card.Title>
			<Row>
				<Col>
					<InfoCard bg='light'>
						<Card.Body>
							<InfoIcon />
							<div className=''>
								{t('impfschaeden.erfassen.datenschutz_text')}
							</div>
						</Card.Body>
					</InfoCard>
				</Col>
				<Col className='d-flex align-items-center justify-content-center m-5'>
					<img
						src='/img/Vorschau_Impfkarte_ohneEintragung.png'
						className='img-fluid shadow-2-strong'
						alt=''
						style={{ width: '472px' }}
					/>
				</Col>
			</Row>
		</>
	);
};

export default Step01;
